import { render, staticRenderFns } from "./AttachmentDialog.vue?vue&type=template&id=b8a102d2&scoped=true&"
import script from "./AttachmentDialog.vue?vue&type=script&lang=js&"
export * from "./AttachmentDialog.vue?vue&type=script&lang=js&"
import style0 from "./AttachmentDialog.vue?vue&type=style&index=0&id=b8a102d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8a102d2",
  null
  
)

export default component.exports